/* eslint-disable no-unused-expressions */
import React, { useEffect, Fragment, useState, useMemo } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import {
  Table, Select, Drawer, Menu, Dropdown, Checkbox, Tag, Popover, Radio, Space, Modal, Spin, Tooltip,
  Divider,
} from 'antd';
import dayjs from 'dayjs';
import { faAnglesRight, faCaretDown, faDownload } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ControlOutlined, CopyOutlined, FilterOutlined, UnlockOutlined, LockOutlined } from '@ant-design/icons';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import Helpers from '@Apis/helpers';
import {
  toISTDate, dateRangePresets, dateRangePresetsValues, entityNameEnum, filterTypeEnums,
} from '@Apis/constants';
import searchIcon from '@Images/icons/icon-search.png';
import H3Text from '@Uilib/h3Text';
import H3Image from '@Uilib/h3Image';
import PurchaseRequestActions from '@Actions/purchaseRequestActions';
import closeIcon from '@Images/icons/icon-close-blue.png';
import DepartmentActions from '@Actions/departmentActions';
import BulkPRSellerSelection from '@Components/Purchase/PurchaseRequests/BulkPoFromPR/BulkPRSellerSelection';
import ViewTableCustomFields from '@Components/Common/CustomField/ViewTableCustomFields';
import CFV2Actions from '@Actions/configurations/cfV2Actions';
import H3DateSelector from '@Uilib/h3DateSelector';
import ProductActions from '@Actions/productActions';
import TenantSelector from '@Components/Common/Selector/TenantSelector';
import SelectDepartment from '@Components/Common/SelectDepartment';
import TagSelector from '@Components/Common/Selector/TagSelector';
import BulkSTForm from '../../BulkSTFromPR/BulkSTForm';
import PRZText from '../../../../Common/UI/PRZText';
import MoreInfoMobileView from '../../../../Common/MoreInfoMobileView';
import { ListScreenKeys } from './helpers';
import useCheckPortrait from '../../../../../hooks/useCheckPortrait';
import PRZSelect from '../../../../Common/UI/PRZSelect/index.jsx';
import './style.scss';
import UserSavedFilterViewSelector from '@Components/Common/UserSavedFilterViewSelector';


const { Option } = Select;

const fixedColumns = ['PR_NUMBER', 'LOCATION'];

function PurchaseRequestsList({
  purchaseRequests, getPurchaseRequestsLoading, user, history, getPurchaseRequestsSuccess, customFieldsProps,
  getPurchaseRequests, getDocCFV2, getDocCFV2Success, getDownloadPRLoading, downloadPRData, departments, getProducts, products, getProductsLoading,
}) {
  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [keyword, setKeyword] = useState('');
  const [searchKeyword, setSearchKeyword] = useState('');
  const [selectedTenant, setSelectedTenant] = useState([]);
  const [isUserReady, setIsUserReady] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState('');
  const [selectedFulfillmentStatus, setSelectedFulfillmentStatus] = useState('');
  const [selectedRows, setSelectedRows] = useState(null);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [createPoDrawer, setCreatePoDrawer] = useState(false);
  const [createStDrawer, setCreateStDrawer] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [searchByProduct, setSearchByProduct] = useState('');
  const [selectedProductId, setSelectedProductId] = useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [selectedTag, setSelectedTag] = useState([]);

  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [selectedEmails, setSelectedEmails] = useState([]);
  const [openPopover, setOpenPopover] = useState(false);
  const [reportType, setReportType] = useState('document_level');
  const [visibleColumns, setVisibleColumns] = useState(localStorage.getItem('prcz-page-columns-pr') ? JSON.parse(localStorage.getItem('prcz-page-columns-pr')) : {
    PR_NUMBER: {
      label: 'MR #',
      visible: true,
    },
    LOCATION: {
      label: 'REQUESTOR LOCATION',
      visible: true,
    },
    ISSUER_LOCATION: {
      label: 'ISSUER LOCATION',
      visible: true,
    },
    ITEMS: {
      label: 'Item(S)',
      visible: true,
    },
    REQUESTOR: {
      label: 'Requestor',
      visible: true,
    },
    DELIVERY_DATE: {
      label: 'Delivery Date',
      visible: true,
    },
    STATUS: {
      label: 'Status',
      visible: true,
    },
    FULFILLMENT_STATUS: {
      label: 'FULFILLMENT STATUS',
      visible: true,
    },
    PURCHASE_ORDERS: {
      label: 'Purchase Orders',
      visible: true,
    },
    STOCK_TRANSFERS: {
      label: 'Stock Transfers',
      visible: true,
    },
    ATTACHMENTS: {
      label: 'Attachments',
      visible: true,
    },
    LABEL: {
      label: 'Labels',
      visible: true,
    },
  });
  const colorArray = ['blue', 'red', 'geekblue', 'green', 'volcano', 'orange', 'cyan', 'purple', 'blue', 'red', 'geekblue', 'green', 'volcano', 'orange', 'cyan', 'purple'];
  const [selectedDepartment, setSelectedDepartment] = useState('');
  const [departmentLevelVisibility, setDepartmentLevelVisibility] = useState(false);
  const [selectedMR, setSelectedMR] = useState({});
  const [moreDetailsDrawer, setMoreDetailsDrawer] = useState(false);

  // filter states
  const [currentDefaultView, setCurrentDefaultView] = useState({});
  const [currentlyAppliedFilters, setCurrentlyAppliedFilters] = useState([]);
  const [selectedFilterView, setSelectedFilterView] = useState({});
  const [isUserReadyInitial, setIsUserReadyInitial] = useState(false);
  const [isUpdateFilterSate, setIsUpdateFilterSate] = useState(true);
  const [savedFilterViews, setSavedFilterViews] = useState([]);
  const [savedFilterViewsLoading, setSavedFilterViewsLoading] = useState(false);
  const [orderDateSelectedIntervalDateRangeType, setOrderDateSelectedIntervalDateRangeType] = useState('');


  const {
    isMobile, isPortrait, isMobileAndPortrait, isMobileOrPortrait,
  } = useCheckPortrait();

  const getPurchaseRequestColumns = () => {
    const purchaseRequestColumns = [
      // {
      //   title: '',
      //   render: (record) => (
      //     <Link to={`/purchase/purchase-request/view/${record.purchase_requisition_id}`}>
      //       <div className="mobile-list__item">
      //         <div style={{ display: 'flex' }}>
      //           <H3Text text={`#${record?.pr_number}`} className="mobile-list__item-number" />
      //           <div className="mobile-list__item-status" style={{ backgroundColor: Helpers.getStatusColor(record.status).color }}>
      //             {Helpers.getStatusColor(record.status).text?.toUpperCase()}
      //           </div>
      //         </div>
      //         <div className="mobile-list__item-info">
      //           <H3Text text={`${record?.tenant_info?.tenant_name} (${record?.tenant_department_alias_name})`} />
      //         </div>
      //         <H3Text text={`Delivery Date - ${toISTDate(record?.delivery_date).format('DD/MM/YYYY')}`} className="mobile-list__item-info" />
      //         <H3Text text={`Requested by ${(record?.created_by_info ? `${record?.created_by_info.first_name} ${record?.created_by_info.last_name}` : 'Unknown')} on ${toISTDate(record?.created_at).format('DD/MM/YYYY')}`} className="mobile-list__item-footer" />
      //       </div>
      //     </Link>
      //   ),
      //   responsive: ['xs'],
      // },
      {
        title: '',
        render: (record) => (
          <div className="mobile-list__card">
            <div className="mobile-list__card_header">
              <div className="mobile-list__card_header-left">
                <PRZText className="mobile-list__card_item-number" text={`#${record?.pr_number ? record.pr_number : 'N/A'}`} />
              </div>
              <div className="mobile-list__card_header-right">
                <PRZText
                  style={{ backgroundColor: Helpers.getStatusColor(record.status).color }}
                  text={Helpers.getStatusColor(record.status).text?.toUpperCase()}
                  className="mobile-list__card__status"
                />
              </div>
            </div>
            <div className="mobile-list__card_body">
              <div className="mobile-list__card_body-left">
                <PRZText
                  text={`Location - ${record?.tenant_info?.tenant_name} (${record?.tenant_department_alias_name})`}
                  className="mobile-list__card_item-details"
                />
                <PRZText
                  text={`Delivery Date - ${toISTDate(record?.delivery_date).format('DD/MM/YYYY')}`}
                  className="mobile-list__card_item-details"
                />
              </div>
            </div>
            <Divider className="mobile-list__card_divider" />
            <div className="mobile-list__card_footer">
              <div className="mobile-list__card_footer-left">
                <PRZText
                  style={{ backgroundColor: Helpers.getStatusColor(record.fulfillment_status).color }}
                  text={Helpers.getStatusColor(record.fulfillment_status).text}
                  className="mobile-list__card_footer__other-status"
                />
              </div>
              <div className="mobile-list__card_footer-right">
                <PRZText
                  className="mobile-list__card__view-more_wrapper"
                  onClick={() => {
                    setSelectedMR(record);
                    setMoreDetailsDrawer(true);
                  }}
                  text={(
                    <span className="mobile-list__card__view-more-text_wrapper">
                      <span className="mobile-list__card__view-more-text">More Info</span>
                      <FontAwesomeIcon
                        className="mobile-list__card__view-more-icon"
                        icon={faAnglesRight}
                      />
                    </span>
                  )}
                />
              </div>
            </div>
          </div>
        ),
        // responsive: ['xs'],
        hidden: !isMobile,
      },
      {
        title: 'MR #',
        render: (record) => (
          <div className="min-width-50">
            {record?.pr_number}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.PR_NUMBER?.visible ? 'display-none' : '',
      },
      {
        title: 'REQUESTOR LOCATION',
        render: (record) => (
          <div className="min-width-70">
            <H3Text text={record?.tenant_info?.tenant_name} />
            <H3Text text={record?.tenant_department_alias_name} className="table-subscript" />
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.LOCATION?.visible ? 'display-none' : '',
      },
      {
        title: 'ISSUER LOCATION',
        render: (record) => (
          <div className="min-width-70">
            <H3Text text={record?.issuer_tenant_info?.tenant_name} />
            <H3Text text={record?.issuer_department_info?.department_name} className="table-subscript" />
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        className: !visibleColumns?.LOCATION?.visible ? 'display-none' : '',
      },
      {
        title: 'ITEM(S)',
        render: (text, record) => (
          <div className="min-width-50">
            {record.lines_count}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.ITEMS?.visible ? 'display-none' : '',

      },
      {
        title: 'REQUESTOR',
        render: (text, record) => (
          <div className="min-width-70">
            {dayjs(record?.created_at).format('DD/MM/YYYY')}
            <H3Text text={(record?.created_by_info ? `${record?.created_by_info.first_name} ${record?.created_by_info.last_name}` : 'Unknown')} className="table-subscript" />
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.REQUESTOR?.visible ? 'display-none' : '',
      },
      {
        title: 'DELIVERY DATE',
        render: (text, record) => (
          <div className="min-width-85">
            {dayjs(record?.delivery_date).format('DD/MM/YYYY')}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.DELIVERY_DATE?.visible ? 'display-none' : '',

      },
      {
        title: 'STATUS',
        render: (item) => (
          <div className="min-width-70">
            <div className="qr__status" style={{ backgroundColor: Helpers.getStatusColor(item.status).color }}>
              {Helpers.getStatusColor(item.status).text}
            </div>
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.STATUS?.visible ? 'display-none' : '',

      },
      {
        title: 'FULFILLMENT STATUS',
        render: (item) => (
          <div className="min-width-130">
            <div className="qr__status" style={{ backgroundColor: Helpers.getStatusColor(item.fulfillment_status).color }}>
              {Helpers.getStatusColor(item.fulfillment_status).text}
            </div>
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.FULFILLMENT_STATUS?.visible ? 'display-none' : '',

      },
      {
        title: 'PURCHASE ORDERS',
        render: (record) => (
          <div className="min-width-130">
            {(() => {
              const validPOs = record?.reference_purchase_orders?.filter((po) => po.status !== 'CANCELLED') || [];
              const firstTwoPOs = validPOs.slice(0, 2);
              const remainingPOs = validPOs.slice(2);
              const remainingCount = remainingPOs.length;

              return (
                <div>
                  {firstTwoPOs.map((po) => (
                    <div key={po.po_id}>
                      <Link to={`/approval?type=po&id=${po.po_id}`} target="_blank">
                        {po.po_number}
                      </Link>
                    </div>
                  ))}
                  {remainingCount > 0 && (
                    <Tooltip
                      title={(
                        <div className="reference-documents-tooltip">
                          {remainingPOs.map((po) => (
                            <div key={po.po_id}>
                              <Link to={`/approval?type=po&id=${po.po_id}`} target="_blank">
                                {po.po_number}
                              </Link>
                            </div>
                          ))}
                        </div>
                      )}
                      placement="top"
                      overlayInnerStyle={{ background: 'white', color: 'black' }}
                    >
                      <div>+{remainingCount} more</div>
                    </Tooltip>
                  )}
                </div>
              );
            })()}
          </div>

        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.PURCHASE_ORDERS?.visible ? 'display-none' : '',

      },
      {
        title: 'STOCK TRANSFERS',
        render: (record) => (
          <div className="min-width-130">
            {(() => {
              const validSTs = record?.reference_stock_transfers?.filter((st) => st.status !== 'VOID') || [];
              const firstTwoSTs = validSTs.slice(0, 2);
              const remainingSTs = validSTs.slice(2);
              const remainingCount = remainingSTs.length;

              return (
                <div>
                  {firstTwoSTs.map((st) => (
                    <div key={st.stock_transfer_id}>
                      <Link to={`/inventory/stock-transfer/view/${st.stock_transfer_id}`} target="_blank">
                        {st.stock_transfer_number}
                      </Link>
                    </div>
                  ))}
                  {remainingCount > 0 && (
                    <Tooltip
                      title={(
                        <div className="reference-documents-tooltip">
                          {remainingSTs.map((st) => (
                            <div key={st.stock_transfer_id}>
                              <Link to={`/inventory/stock-transfer/view/${st.stock_transfer_id}`} target="_blank">
                                {st.stock_transfer_number}
                              </Link>
                            </div>
                          ))}
                        </div>
                      )}
                      placement="top"
                      overlayInnerStyle={{ background: 'white', color: 'black' }}
                    >
                      <div>+{remainingCount} more</div>
                    </Tooltip>
                  )}
                </div>
              );
            })()}
          </div>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.STOCK_TRANSFERS?.visible ? 'display-none' : '',
      },
      {
        title: 'ATTACHMENTS',
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        render: (text, record) => (
          <div className="min-width-100">
            {
              record?.attachments?.map((item, index) => (
                <div>
                  <a href={item?.url} target="_blank" rel="noreferrer">{`Link# ${index + 1}`}</a>
                </div>
              ))
            }
          </div>
        ),
        className: !visibleColumns?.ATTACHMENTS?.visible ? 'display-none' : '',
      },
      {
        title: 'LABELS',
        render: (item) => (
          <Fragment>
            <div className="table-labels__list min-width-70">
              <div>
                <Space size={[0, 8]} wrap>
                  {item?.tags?.map((tag, index) => (
                    <Tag
                      key={index}
                      color={colorArray[index]}
                    >
                      {tag}
                    </Tag>
                  ))}
                </Space>
              </div>
            </div>
          </Fragment>
        ),
        responsive: ['sm', 'md', 'lg', 'xxl'],
        hidden: isMobile,
        className: !visibleColumns?.LABEL?.visible ? 'display-none' : '',
      },
    ];
    if (customFieldsProps?.data?.document_custom_fields?.length) {
      const customs = customFieldsProps?.data?.document_custom_fields;
      customs?.filter((item) => item?.is_active)?.filter((item) => item?.is_active)?.map((custom) => {
        purchaseRequestColumns.push({
          title: custom.field_name,
          render: (record) => (
            <div className={Helpers.setColumnMinimumWidth(custom?.field_name)}>
              <ViewTableCustomFields customField={record.custom_fields?.filter((subItem) => subItem.cf_id === custom.cf_id)?.[0]} />
            </div>
          ),
          responsive: ['sm', 'md', 'lg', 'xxl'],
          hidden: isMobile,
          className: !visibleColumns?.[custom.cf_id]?.visible ? 'display-none' : '',
        });
      });
    }
    purchaseRequestColumns.push({
      title: '',
      key: 'action',
      render: (text, record) => (
        <div className="list__actions" style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'flex-end' }}>
          <div
            key={record.purchase_requisition_id}
            className=" list__actions-button"
            onClick={() => {
              if (!isRowDisabled(record)) {
                window.open(`/purchase/purchase-request/create?clonePrData=${record.purchase_requisition_id}`);
              }
            }}
          >
            <Tooltip
              placement="topLeft"
              title="Make a Copy"
            >
              <CopyOutlined
                className="action-button"
                style={{
                  justifyContent: 'center',
                  fontSize: '16px',
                }}
              />
            </Tooltip>
          </div>
          <div
            className="list__actions-button list__actions-button-dark"
            onClick={() => {
              if (!isRowDisabled(record)) {
                history.push(`/purchase/purchase-request/view/${record.purchase_requisition_id}`);
              }
            }}
          >
            View
          </div>
          {user?.tenant_info?.purchase_config?.sub_modules?.purchase_request?.is_active && (
            <div
              className="list__actions-button mo__action-button"
            >
              {!isRowDisabled(record) ? <UnlockOutlined /> : <LockOutlined />}
            </div>
          )}
        </div>
      ),
      className: 'list__actions-column',
      responsive: ['sm', 'md', 'lg', 'xxl'],
      hidden: isPortrait,
      fixed: 'right',
    });
    return purchaseRequestColumns.filter((item) => !item.hidden);
  };

  // common function to get filter value by key
  function getFilterValueByKey({ filtersArray, key, valueOnly = true }) {
    const selectedFilter = filtersArray.find((item) => item.filter_key === key) || null;
    return valueOnly ? selectedFilter?.filter_value : selectedFilter;
  }

  function getAppliedFiltersFromURL() {

    const appliedFiltersFromURL = [
      {
        filter_key: 'limit',
        filter_value: Number(Helpers.getValueFromUrl('limit') || limit),
        filter_type: filterTypeEnums.NUMBER,
      },
      {
        filter_key: 'keyword',
        filter_value: Helpers.getValueFromUrl('keyword') || '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'tenant',
        filter_value: Helpers.getValueFromUrl('tenant') ? Helpers.getValueFromUrl('tenant')?.split(',')?.map((item) => (parseInt(item))) : [],
        filter_type: filterTypeEnums.ARRAY,
      },
      {
        filter_key: 'status',
        filter_value: Helpers.getValueFromUrl('status') || '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'fulfillment_status',
        filter_value: Helpers.getValueFromUrl('fulfillment_status') || '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'label',
        filter_value: Helpers.getValueFromUrl('label') ? Helpers.getValueFromUrl('label')?.split(',')?.map((item) => item) : [],
        filter_type: filterTypeEnums.ARRAY,
      },
      {
        filter_key: 'department_ids',
        filter_value: Number(Helpers.getValueFromUrl('department_ids')) || '',
        filter_type: filterTypeEnums.NUMBER,
      },
      {
        filter_key: 'startDate',
        filter_value: Number(Helpers.getValueFromUrl('startDate')) || '',
        filter_type: filterTypeEnums.DATE_RANGE,
        date_range_type: Helpers.getValueFromUrl('order_date_type') || '',
      },
      {
        filter_key: 'endDate',
        filter_value: Number(Helpers.getValueFromUrl('endDate')) || '',
        filter_type: filterTypeEnums.DATE_RANGE,
        date_range_type: Helpers.getValueFromUrl('order_date_type') || '',
      },
    ];
    return appliedFiltersFromURL;
  }

  const initialFilterValues = useMemo(() => {
    return [
      {
        filter_key: 'limit',
        filter_value: limit,
        filter_type: filterTypeEnums.NUMBER,
      },
      {
        filter_key: 'keyword',
        filter_value: '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'tenant',
        filter_value: [user?.tenant_info?.tenant_id],
        filter_type: filterTypeEnums.ARRAY,
      },
      {
        filter_key: 'status',
        filter_value: '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'fulfillment_status',
        filter_value: '',
        filter_type: filterTypeEnums.STRING,
      },
      {
        filter_key: 'label',
        filter_value: [],
        filter_type: filterTypeEnums.ARRAY,
      },
      {
        filter_key: 'department_ids',
        filter_value: Helpers.getTenantDepartmentId(user) !== user?.tenant_info?.default_store_id && user?.tenant_info?.inventory_config?.settings?.department_wise_visibility ? Number(Helpers.getDepartmentId(user)) : '',
        filter_type: filterTypeEnums.NUMBER,
      },
      {
        filter_key: 'startDate',
        filter_value: '',
        filter_type: filterTypeEnums.DATE_RANGE,
        date_range_type: '',
      },
      {
        filter_key: 'endDate',
        filter_value: '',
        filter_type: filterTypeEnums.DATE_RANGE,
        date_range_type: '',
      },
    ];
  }, []);

  const systemDefaultUserView = useMemo(() => ({
    filter_id: 'system_default',
    filter_name: 'System Default View',
    entity_name: entityNameEnum.PURCHASE_REQUEST,
    filters: initialFilterValues,
    tenant_id: user?.tenant_info?.tenant_id,
    org_id: user?.user_org_id,
    user_id: user?.user_id,
    is_default: false,
    is_system_default: true,
  }), []);


  useEffect(() => {
    // Start a timer with the debounce delay
    const handler = setTimeout(() => {
      if (searchByProduct) {
        getProducts(searchByProduct, user?.tenant_info?.tenant_id, '', 5, 1, '', '', '', '', '', '', '');
      }
    }, 500); // 500ms debounce time
    // Cleanup function to clear the timer
    return () => {
      clearTimeout(handler);
    };
  }, [searchByProduct]);

  useEffect(() => {
    if (customFieldsProps?.data?.document_custom_fields?.length) {
      const customFields = customFieldsProps?.data?.document_custom_fields;
      const columns = JSON.parse(JSON.stringify(visibleColumns));
      customFields?.filter((item) => item?.is_active)?.map((customField) => {
        columns[customField.cf_id] = {
          label: customField?.field_name,
          visible: JSON.parse(localStorage.getItem('prcz-page-columns-pr'))?.[customField.cf_id]?.visible || false,
        };
      });

      setVisibleColumns(columns);
    }
  }, [customFieldsProps]);

  const pushParamsToUrl = (page, limit, currentTenant, currentDepartment, status, fulfillmentStatus, word, start, end, productSearch, tags, orderDateSelectedIntervalDateRangeType, selectedFilterView) => {
    let url = '';
    if (page) url += `?page=${page}`;
    if (limit) url += `&limit=${limit}`;
    if (currentTenant) url += `&tenant=${currentTenant}`;
    if (status) url += `&status=${status}`;
    if (fulfillmentStatus) url += `&fulfillment_status=${fulfillmentStatus}`;
    if (word) url += `&keyword=${word}`;
    if (start) url += `&startDate=${start}`;
    if (end) url += `&endDate=${end}`;
    if (currentDepartment) url += `&department_ids=${currentDepartment}`;
    if (productSearch) url += `&product_search=${productSearch}`;
    if (tags) url += `&label=${tags}`;
    if (selectedFilterView) url += `&filter_id=${selectedFilterView?.filter_id}`;
    if (orderDateSelectedIntervalDateRangeType) url += `&order_date_type=${orderDateSelectedIntervalDateRangeType}`;
    history.push(url);
  };



  const getDataSource = (data) => {
    if (data) {
      const copyData = [];
      for (let i = 0; i < data?.length; i++) {
        copyData.push({
          ...data?.[i],
          key: data?.[i]?.purchase_requisition_id,
        });
      }
      return copyData;
    }
    return [];
  };
  const addEmails = (value) => { setSelectedEmails(value); };
  const downloadHandler = () => {
    const visibleColumnKeys = Object.entries(visibleColumns)
      .filter(([key, value]) => value.visible)
      .map(([key]) => key.toLowerCase())
      .join(',');
    const numbersArray = [];
    const stringsArray = [];
    const emailsArray = selectedEmails;

    const dataList = visibleColumnKeys.split(',');
    dataList.forEach((item) => {
      if (!isNaN(item)) {
        numbersArray.push(Number(item));
      } else {
        stringsArray.push(item);
      }
    });

    const numbersString = numbersArray.join(',');
    const stringsString = stringsArray.join(',');
    const emailsString = emailsArray.join(',');

    const payload = {
      org_id: user?.tenant_info?.org_id,
      tenant_id: selectedTenant?.filter((item) => !isNaN(item))?.length > 0 ? selectedTenant?.join(',') : Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.SALES_ORDER, Helpers.permissionTypes.READ)?.join(','),
      search_keyword: Helpers.getValueFromUrl('keyword'),
      status: Helpers.getValueFromUrl('status'),
      department_ids: selectedDepartment,
      columns: stringsString,
      custom_fields: numbersString,
      no_wait: true,
      emails: emailsString,
      type: 'send_email',
      level: reportType,
      from_date: dayjs(startDate).isValid() ? dayjs(startDate).format('YYYY-MM-DD') : null,
      to_date: dayjs(endDate).isValid() ? dayjs(endDate).format('YYYY-MM-DD') : null,
      user_id: user?.user_id,
    };

    if (!getDownloadPRLoading) {
      downloadPRData(payload, () => {
        setOpenPopover(false);
      });
    }
  };

  const handleChange = (value, option) => {
    setSelectedProductId(value);
    setSelectedProducts(option);
  };

  const materialRequestStatusOptions = [
    { key: '', value: '', label: 'All Material Requests' },
    { key: 'DRAFT', value: 'DRAFT', label: 'Draft' },
    { key: 'SENT_FOR_APPROVAL', value: 'SENT_FOR_APPROVAL', label: 'Sent For Approval' },
    { key: 'ISSUED', value: 'ISSUED', label: 'Issued' },
    { key: 'COMPLETED', value: 'COMPLETED', label: 'Closed' },
    { key: 'CANCELLED', value: 'CANCELLED', label: 'Cancelled' },
  ];

  const fulfillmentStatusOptions = [
    { key: null, value: null, label: 'All Fulfillment Status' },
    { key: 'FULFILLED', value: 'FULFILLED', label: 'Fulfilled' },
    { key: 'PARTIALLY_FULFILLED', value: 'PARTIALLY_FULFILLED', label: 'Partially Fulfilled' },
    { key: 'PENDING', value: 'PENDING', label: 'Pending' },
  ];

  // Disable if:
  // 1. View restriction is enabled AND user doesn't have access (→ hide/disable row)
  // 2. Or always prevent selection if user doesn't have access

  const isRowDisabled = (record) => {
    const configEnabled = user?.tenant_info?.purchase_config?.sub_modules?.purchase_request?.settings?.enable_issuer_department_restriction_on_view_mr;

    if (!configEnabled) return false;

    // Case: issuer_tenant_id is null — accessible to all
    if (record?.issuer_tenant_id === null) return false;

    // Case: Same tenant (issuer and requestor)
    if (record?.issuer_tenant_id === record?.tenant_id) {
      const { userTenantDepartmentId, tenantDefaultStoreId } =
        Helpers.getUserTenantDepartmentIds(user, record?.tenant_id);

      const isAccessible =
        record?.tenant_department_id === userTenantDepartmentId ||
        record?.issuer_tenant_department_id === userTenantDepartmentId ||
        userTenantDepartmentId === tenantDefaultStoreId;

      return !isAccessible;
    }

    // Case: Different tenants (issuer and requestor)
    const {
      userTenantDepartmentId: userTenantDepartmentIdRequestor,
      tenantDefaultStoreId: tenantDefaultStoreIdRequestor,
    } = Helpers.getUserTenantDepartmentIds(user, record?.tenant_id);

    const {
      userTenantDepartmentId: userTenantDepartmentIdIssuer,
      tenantDefaultStoreId: tenantDefaultStoreIdIssuer,
    } = Helpers.getUserTenantDepartmentIds(user, record?.issuer_tenant_id);

    const isAccessible =
      record?.tenant_department_id === userTenantDepartmentIdRequestor ||
      record?.issuer_tenant_department_id === userTenantDepartmentIdIssuer ||
      userTenantDepartmentIdRequestor === tenantDefaultStoreIdRequestor ||
      userTenantDepartmentIdIssuer === tenantDefaultStoreIdIssuer;

    return !isAccessible;
  };

  useEffect(() => {
    if (user?.tenant_info?.org_id) {
      // setCurrentPage(Number(Helpers.getValueFromUrl('page') || currentPage));
      // setLimit(Number(Helpers.getValueFromUrl('limit') || limit));
      // setSelectedTenant(Helpers.getValueFromUrl('tenant') ? Helpers.getValueFromUrl('tenant')?.split(',')?.map((item) => (parseInt(item))) : [user?.tenant_info?.tenant_id]);
      // setSelectedStatus(Helpers.getValueFromUrl('status'));
      // setSelectedFulfillmentStatus(Helpers.getValueFromUrl('fulfillment_status'));
      // setSearchKeyword(Helpers.getValueFromUrl('keyword'));
      // setKeyword(Helpers.getValueFromUrl('keyword'));
      // setSelectedEmails([user?.email]);
      // setStartDate((Helpers.getValueFromUrl('from_date')));
      // setEndDate((Helpers.getValueFromUrl('to_date')));
      // setSelectedTag(Helpers.getValueFromUrl('label') ? Helpers.getValueFromUrl('label')?.split(',')?.map((item) => item) : []);
      const payload = {
        orgId: user?.tenant_info?.org_id,
        entityName: 'PURCHASE_REQUEST',
      };
      getDocCFV2(payload);
      // if (Helpers.getTenantDepartmentId(user) !== user?.tenant_info?.default_store_id && user?.tenant_info?.inventory_config?.settings?.department_wise_visibility) {
      //   setDepartmentLevelVisibility(user?.tenant_info?.inventory_config?.settings?.department_wise_visibility);
      //   setSelectedDepartment(Helpers.getValueFromUrl('department') || Helpers.getDepartmentId(user)?.toString());
      // } else {
      //   setSelectedDepartment(Helpers.getValueFromUrl('department'));
      // }

      // setIsUserReady(true);
      setSelectedFilterView(systemDefaultUserView);
    }
    return () => {
      getDocCFV2Success(null);
    };
  }, []);

  useEffect(() => {
    if (savedFilterViews && isUserReadyInitial) {
      const defaultUserView = savedFilterViews.find((item) => item.is_default);

      if (defaultUserView) {
        setCurrentDefaultView(defaultUserView);
      } else {
        setCurrentDefaultView(systemDefaultUserView);
      }

      const appliedFiltersFromURL = getAppliedFiltersFromURL();

      const selectedFilterViewFromURL = Helpers.getValueFromUrl('filter_id');

      let currentSelectedView;
      if (selectedFilterViewFromURL) {
        currentSelectedView = savedFilterViews.find((item) => String(item.filter_id) === String(selectedFilterViewFromURL));
        if (!currentSelectedView) {
          currentSelectedView = systemDefaultUserView;
        }
      } else {
        currentSelectedView = defaultUserView || systemDefaultUserView;
      }

      const filterValues = (isFromURL) => {
        const currentSelectedViewFilters = currentSelectedView.filters;

        const filterValue = initialFilterValues.map((item) => item.filter_key).reduce((acc, filterKey) => ({ ...acc, [filterKey]: getFilterValueByKey({ filtersArray: isFromURL ? appliedFiltersFromURL : currentSelectedViewFilters, key: filterKey }) }), {});

        const _orderDateRangeType = getFilterValueByKey({ filtersArray: isFromURL ? appliedFiltersFromURL : currentSelectedViewFilters, key: 'startDate', valueOnly: false }).date_range_type;

        let _orderStartDate = '';
        let _orderEndDate = '';

        if (_orderDateRangeType === '' || _orderDateRangeType === dateRangePresets.CUSTOM) {
          // No action needed for empty or custom date range type
        } else {
          const date = dateRangePresetsValues(_orderDateRangeType);
          const [start, end] = date;

          _orderStartDate = start;
          _orderEndDate = end;
          filterValue.startDate = _orderStartDate;
          filterValue.endDate = _orderEndDate;
        }
        filterValue.orderDateRangeType = _orderDateRangeType;

        return filterValue;
      };

      const tempFilterValues = filterValues(selectedFilterViewFromURL);

      setSelectedFilterView(currentSelectedView);
      if (isUpdateFilterSate) {
        setCurrentlyAppliedFilters(appliedFiltersFromURL);

        setSelectedEmails([user?.email]);

        setCurrentPage(Number(Helpers.getValueFromUrl('page') || currentPage));
        setLimit(tempFilterValues.limit || limit);
        setSelectedTenant(tempFilterValues.tenant);
        setSelectedStatus(tempFilterValues.status);
        setSelectedFulfillmentStatus(tempFilterValues.fulfillment_status);
        setSearchKeyword(tempFilterValues.keyword);
        setKeyword(tempFilterValues.keyword);
        setStartDate(tempFilterValues.startDate);
        setEndDate(tempFilterValues.endDate);
        setSelectedTag(tempFilterValues.label);
        setOrderDateSelectedIntervalDateRangeType(tempFilterValues.orderDateRangeType);
        setSelectedDepartment(tempFilterValues.department_ids);

        if (Helpers.getTenantDepartmentId(user) !== user?.tenant_info?.default_store_id && user?.tenant_info?.inventory_config?.settings?.department_wise_visibility) {
          setDepartmentLevelVisibility(user?.tenant_info?.inventory_config?.settings?.department_wise_visibility);
          // setSelectedDepartment(Helpers.getValueFromUrl('department') || Helpers.getDepartmentId(user)?.toString());
        } else {
          // setSelectedDepartment(Helpers.getValueFromUrl('department'));
        }
      }

      if (!isUserReady) setIsUserReady(true);
      if (!isUpdateFilterSate) setIsUpdateFilterSate(true);
    }
  }, [savedFilterViews, isUserReadyInitial]);

  useEffect(() => {
    if (isUserReady) {
      pushParamsToUrl(currentPage, limit, selectedTenant, selectedDepartment, selectedStatus, selectedFulfillmentStatus, searchKeyword, startDate, endDate, selectedProductId, selectedTag, orderDateSelectedIntervalDateRangeType, selectedFilterView);
      setCurrentlyAppliedFilters(getAppliedFiltersFromURL());
      getPurchaseRequestsSuccess(null);
      const startDateFormatted = Helpers.getValueFromUrl('startDate') ? dayjs(Number(Helpers.getValueFromUrl('startDate'))).format('YYYY-MM-DD') : "";
      const endDateFormatted = Helpers.getValueFromUrl('endDate') ? dayjs(Number(Helpers.getValueFromUrl('endDate'))).format('YYYY-MM-DD') : "";
      getPurchaseRequests(selectedTenant?.filter((item) => !isNaN(item))?.length > 0 ? selectedTenant?.join(',') : Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.SALES_ORDER, Helpers.permissionTypes.READ)?.join(','), Helpers.getValueFromUrl('status'),
        startDateFormatted, endDateFormatted, null, null, null, Helpers.getValueFromUrl('page'), Helpers.getValueFromUrl('limit'), '', Helpers.getValueFromUrl('keyword'), null, null, null, null, selectedDepartment, Helpers.getValueFromUrl('product_search'), Helpers.getValueFromUrl('label'), null, Helpers.getValueFromUrl('fulfillment_status'), true);
    }
  }, [selectedStatus, selectedFulfillmentStatus, selectedTenant, selectedDepartment, searchKeyword, currentPage, limit, startDate, endDate, selectedProductId, selectedTag, orderDateSelectedIntervalDateRangeType]);

  return (
    <Fragment>
      <Drawer
        open={moreDetailsDrawer}
        mask
        onClose={() => setMoreDetailsDrawer(false)}
        destroyOnClose
        rootClassName="mobile__more-details_wrapper"
      >
        <div className="custom-drawer__header-wrapper">
          <div
            className="custom-drawer__header"
          >
            <H3Text
              text={`MR # ${selectedMR?.pr_number}`}
              className="custom-drawer__title"
            />
            <H3Image
              src={closeIcon}
              className="custom-drawer__close-icon"
              onClick={() => setMoreDetailsDrawer(false)}
            />
          </div>
        </div>
        <MoreInfoMobileView
          customFields={selectedMR?.custom_fields}
          fields={ListScreenKeys({ documentData: selectedMR })}
        />
      </Drawer>
      <Modal
        title={(
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <img
              alt="shopify icon"
              src={searchIcon} // Make sure 'searchIcon' is defined and imported
              width={20}
              height={20}
              style={{ marginRight: 10 }}
            />
            <div>Search By Product Name</div>
            &nbsp;  &nbsp;
            {getProductsLoading && <Spin size="small" />}
          </div>
        )}
        getContainer={() => document.querySelector('.trigger-modal-btn')}
        style={{
          top: '17px',
          left: isMobileOrPortrait ? '-1%' : '6%',
          width: '520px',
        }}
        open={isModalOpen}
        onOk={() => {
          setIsModalOpen(false);
        }}
        onCancel={() => {
          setIsModalOpen(false);
        }}
        footer={null}
        mask
        maskClosable
        closeIcon={null}
      >
        <div className="section-search">
          <div className="section-search-bar__wrapper" style={{ width: '100%' }}>
            <PRZSelect
              showSearch
              mode="multiple"
              style={{ width: '100%' }}
              placeholder="Select a product"
              optionFilterProp="children"
              onSearch={(value) => setSearchByProduct(value)}
              value={selectedProductId}
              onChange={handleChange}
              loading={getProductsLoading}
              filterOption={(input, option) => option?.children?.toLowerCase()?.indexOf(input.toLowerCase()) >= 0}
            >
              {products?.result?.products?.map((product) => (
                <Option key={product.product_sku_id} value={product.product_sku_id}>
                  {product?.product_info?.product_sku_name}
                </Option>
              ))}
            </PRZSelect>
          </div>
        </div>
      </Modal>
      <Drawer
        open={createPoDrawer}
        width="1080px"
        mask
        onClose={() => setCreatePoDrawer(false)}
        destroyOnClose
      >
        <Fragment>
          <div className="custom-drawer__header-wrapper">
            <div className="custom-drawer__header" style={{ width: '1025px' }}>
              <H3Text text="Create Purchase Orders for Material Requests" className="custom-drawer__title" />
              <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setCreatePoDrawer(false)} />
            </div>
          </div>
          <BulkPRSellerSelection
            selectedRows={selectedRows}
            selectedTenants={selectedTenant?.filter((item) => !isNaN(item))?.length > 0 ? selectedTenant?.join(',') : Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.PURCHASE_REQUEST, Helpers.permissionTypes.READ)?.join(',')}
            toggleBulkPoDrawer={() => {
              setSelectedRows([]);
              setSelectedRowKeys([]);
              setCreatePoDrawer(!createPoDrawer);
              getPurchaseRequests(selectedTenant?.filter((item) => !isNaN(item))?.length > 0 ? selectedTenant?.join(',') : Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.PURCHASE_REQUEST, Helpers.permissionTypes.READ)?.join(','), selectedStatus, null, null, null, null, null, currentPage, limit, null, null, null, null, null, null, null, null, null, null, selectedFulfillmentStatus);
            }}
          />
        </Fragment>
      </Drawer>
      <Drawer
        open={createStDrawer}
        width="1200px"
        mask
        onClose={() => setCreateStDrawer(false)}
        destroyOnClose
      >
        <Fragment>
          <div className="custom-drawer__header-wrapper">
            <div className="custom-drawer__header" style={{ width: '1150px' }}>
              <H3Text text="Create Stock Transfer for Material Requests" className="custom-drawer__title" />
              <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setCreateStDrawer(false)} />
            </div>
          </div>
          <BulkSTForm
            selectedRows={selectedRows}
            selectedTenants={selectedTenant?.filter((item) => !isNaN(item))?.length > 0 ? selectedTenant?.join(',') : Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.PURCHASE_REQUEST, Helpers.permissionTypes.READ)?.join(',')}
            toggleBulkSTDrawer={() => {
              setSelectedRows([]);
              setSelectedRowKeys([]);
              setCreateStDrawer(!createStDrawer);
              getPurchaseRequests(selectedTenant?.filter((item) => !isNaN(item))?.length > 0 ? selectedTenant?.join(',') : Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.PURCHASE_REQUEST, Helpers.permissionTypes.READ)?.join(','), selectedStatus, null, null, null, null, null, currentPage, limit, null, null, null, null, null, null, null, null, null, null, selectedFulfillmentStatus);
            }}
          />
        </Fragment>
      </Drawer>
      <div className="doc-list__wrapper">
        <div className="ant-row">
          <div className="ant-col-md-24 ant-col-xs-24">
            <div className="doc-list__header-wrapper">
              <div className="doc-list__header-wrapper__left">
                <div className="section-search">
                  <div className="doc-list__search-bar__wrapper">
                    <div className="section-search-bar">
                      <input
                        value={keyword}
                        placeholder="Search for Material Request..."
                        onKeyDown={(e) => {
                          if (e.key === 'Enter') {
                            setSearchKeyword(e.target.value);
                            setCurrentPage(1);
                          }
                        }}
                        onChange={(event) => {
                          setKeyword(event.target.value);
                        }}
                      />
                      <H3Image
                        src={searchIcon}
                        className="section-search-bar__icon"
                        alt="search"
                        onClick={() => {
                          setSearchKeyword(keyword);
                          setCurrentPage(1);
                        }}
                      />
                    </div>
                  </div>
                </div>
                <div className="section-search">
                  <div className="search-by-product-modal-btn">
                    <H3Text
                      text={(
                        <div className="new-action-button-wrapper" onClick={() => setIsModalOpen(true)}>
                          <Fragment>
                            <div className="action-button-text">Search By Products </div>
                            <div className="action-button-text_mobile">Search</div>
                            &nbsp;  &nbsp;
                            <H3Image src={searchIcon} className="action-button-icon" />
                          </Fragment>
                        </div>
                      )}
                      className="action-button action-button-big"
                    />
                  </div>
                </div>
              </div>
              <div className="doc-list__header-wrapper__right">
                <div className="doc-list__buttons-wrapper">
                  {Helpers.getPermission(Helpers.permissionEntities.PURCHASE_REQUEST, Helpers.permissionTypes.CREATE, user) && (
                    <H3Button
                      buttonType={defaultButtonTypes.BLUE_ROUNDED}
                      text="+ New Material Request"
                      onClick={() => history.push('/purchase/purchase-request/create')}
                      customClass="add-button"
                    />
                  )}
                </div>
              </div>
            </div>
            <div className="flex-align-c" style={{ gap: '10px' }}>
              <UserSavedFilterViewSelector
                selectedFilterView={selectedFilterView}
                onChangeTab={(currentSelectedView) => {
                  setSelectedFilterView(() => {
                    const currentSelectedViewFilters = currentSelectedView.filters;

                    const filterValue = initialFilterValues.map((item) => item.filter_key).reduce((acc, filterKey) => ({ ...acc, [filterKey]: getFilterValueByKey({ filtersArray: currentSelectedViewFilters, key: filterKey }) }), {});

                    const _orderDateRangeType = getFilterValueByKey({ filtersArray: currentSelectedViewFilters, key: 'startDate', valueOnly: false }).date_range_type;

                    let _orderStartDate = '';
                    let _orderEndDate = '';

                    if (_orderDateRangeType === '' || _orderDateRangeType === dateRangePresets.CUSTOM) {
                      // No action needed for empty or custom date range type
                    } else {
                      const date = dateRangePresetsValues(_orderDateRangeType);
                      const [start, end] = date;

                      _orderStartDate = start;
                      _orderEndDate = end;
                      filterValue.startDate = _orderStartDate;
                      filterValue.endDate = _orderEndDate;
                    }

                    filterValue.orderDateRangeType = _orderDateRangeType;

                    const tempFilterValues = filterValue;
                    setCurrentPage(1);
                    setLimit(tempFilterValues.limit || limit);
                    setSearchKeyword(tempFilterValues.keyword);
                    setKeyword(tempFilterValues.keyword);
                    setSelectedStatus(tempFilterValues.status);
                    setSelectedFulfillmentStatus(tempFilterValues.fulfillment_status);
                    setSelectedTenant(tempFilterValues.tenant);
                    setSelectedTag(tempFilterValues.label);
                    setStartDate(tempFilterValues.startDate);
                    setEndDate(tempFilterValues.endDate);
                    setOrderDateSelectedIntervalDateRangeType(tempFilterValues.orderDateRangeType);
                    setSelectedDepartment(tempFilterValues.department_ids);

                    return currentSelectedView;
                  });
                }}
                currentlyAppliedFilters={currentlyAppliedFilters}
                entityName={entityNameEnum.PURCHASE_REQUEST}
                setSavedFilterViews={(value) => setSavedFilterViews(value)}
                setSavedFilterViewsLoading={(value) => setSavedFilterViewsLoading(value)}
                setIsUpdateFilterSate={(value) => setIsUpdateFilterSate(value)}
                callback={() => {
                  if (!isUserReadyInitial) setIsUserReadyInitial(true);
                }}
                systemDefaultUserView={systemDefaultUserView}
              />
              <div className="header__tags">
                {searchKeyword && (
                  <Tag closable onClose={() => { setSearchKeyword(''); setKeyword(''); setCurrentPage(1); }} color="#2d7df7">
                    Search results for -
                    &nbsp;
                    <span><b>{searchKeyword}</b></span>
                  </Tag>
                )}
                {selectedTag && selectedTag?.map((item, index) => (
                  <Tag
                    key={index}
                    closable
                    onClose={() => {
                      setCurrentPage(1);
                      setSelectedTag(selectedTag?.filter((tId) => tId !== item));
                    }}
                    color="#2d7df7"
                  >
                    Label -
                    &nbsp;
                    <span>
                      <b>{item?.toUpperCase()}</b>
                    </span>
                  </Tag>
                ))}
                {selectedStatus && (
                  <Tag closable onClose={() => { setSelectedStatus(null); setCurrentPage(1); }} color="#2d7df7">
                    Status -
                    &nbsp;
                    <span><b>{selectedStatus?.replaceAll('_', ' ')?.toUpperCase()}</b></span>
                  </Tag>
                )}
                {selectedFulfillmentStatus && (
                  <Tag closable onClose={() => { setSelectedFulfillmentStatus(null); setCurrentPage(1); }} color="#2d7df7">
                    Fulfillment Status -
                    &nbsp;
                    <span><b>{selectedFulfillmentStatus?.replaceAll('_', ' ')?.toUpperCase()}</b></span>
                  </Tag>
                )}
                {selectedTenant && selectedTenant?.map((item, index) => (
                  <Tag
                    key={index}
                    closable
                    onClose={() => {
                      setCurrentPage(1);
                      setSelectedTenant(selectedTenant.filter((tId) => tId !== item));
                    }}
                    color="#2d7df7"
                  >
                    Business Unit -
                    &nbsp;
                    <span>
                      <b>{user?.user_tenants?.find((tenant) => tenant?.tenant_id == item)?.tenant_name?.toUpperCase()}</b>
                    </span>
                  </Tag>
                ))}
                {!!selectedDepartment && (
                  <Tag closable={!departmentLevelVisibility} onClose={() => { setSelectedDepartment(null); setSelectedRows([]); setCurrentPage(1); }} color="#2d7df7">
                    {' '}
                    Department -
                    &nbsp;
                    <span><b>{departments?.data?.result?.departments?.find((item) => Number(item?.department_id) === Number(selectedDepartment))?.department_info?.department_name?.toUpperCase()}</b></span>
                  </Tag>
                )}
                {
                  (startDate && endDate) ? (
                    <Tag
                      closable
                      onClose={() => {
                        setStartDate(null);
                        setEndDate(null);
                        setOrderDateSelectedIntervalDateRangeType('');
                      }}
                      color="#2d7df7"
                    >
                      {' '}
                      From:
                      &nbsp;
                      <span><b>{dayjs(startDate).format('DD/MM/YYYY')}</b></span>
                      &nbsp;
                      To:
                      &nbsp;
                      <span><b>{dayjs(endDate).format('DD/MM/YYYY')}</b></span>
                    </Tag>
                  ) : ''
                }
                {
                  selectedProductId?.length > 0 && selectedProductId?.map((item, index) => (
                    <Tag
                      key={index}
                      closable
                      onClose={() => {
                        setSelectedProductId(selectedProductId?.filter((id) => id !== item));
                      }}
                      color="#2d7df7"
                    >
                      {' '}
                      Product -
                      &nbsp;
                      <span><b>{selectedProducts?.find((product) => product.value === item)?.children}</b></span>
                    </Tag>
                  ))
                }
              </div>
            </div>
            <div className="doc-list__table-wrapper">
              <Table
                title={() => (
                  <div className="doc-list__table-header">
                    <div className="doc-list__table-header__left">
                      <H3Text text={`${(purchaseRequests && purchaseRequests.count) ? purchaseRequests.count : '0'} Material Requests`} className="" />
                    </div>
                    <div className="doc-list__table-header__right">
                      <div className="doc-list__filter-buttons">
                        {
                          purchaseRequests && purchaseRequests.count > 0
                          && (
                            <Popover
                              placement="bottom"
                              trigger="click"
                              title={<div className="download-btn-popover__title">Please provide your email address</div>}
                              open={openPopover}
                              onOpenChange={() => setOpenPopover(!openPopover)}
                              content={(
                                <React.Fragment>
                                  <div>
                                    <PRZSelect
                                      getPopupContainer={(triggerNode) => triggerNode.parentNode}
                                      mode="tags"
                                      filterOption={false}
                                      value={selectedEmails}
                                      onChange={addEmails}
                                      disabled={getDownloadPRLoading}
                                      maxTagCount="responsive"
                                      style={{
                                        width: '300px',
                                        height: 'auto !important',
                                      }}
                                      placeholder=""
                                    >

                                      {selectedEmails.length > 0 ? (
                                        selectedEmails.map((item) => (
                                          <Option key={item} value={item}>
                                            {item}
                                          </Option>
                                        ))
                                      ) : (
                                        <Option key={user?.email} value={user?.email}>
                                          {user?.email}
                                        </Option>
                                      )}

                                    </PRZSelect>
                                  </div>
                                  <div className="mg-top-10">
                                    <Radio.Group onChange={(event) => setReportType(event?.target?.value)} disabled={getDownloadPRLoading} value={reportType}>
                                      <Space direction="vertical">
                                        <Radio key="1" value="document_level">Material Requests Data</Radio>
                                        <Radio key="2" value="line_level">Material Request Items Data</Radio>
                                      </Space>
                                    </Radio.Group>
                                  </div>
                                  <div className="mg-top-10">
                                    <H3Button
                                      text="Send"
                                      buttonType={defaultButtonTypes.BLUE_ROUNDED}
                                      onClick={() => downloadHandler()}
                                      customClass="email-submit"
                                      isLoading={getDownloadPRLoading}
                                      disabled={getDownloadPRLoading}
                                    >
                                      Send

                                    </H3Button>
                                  </div>

                                </React.Fragment>
                              )}
                            >
                              <div
                                className={`download-btn ${getDownloadPRLoading ? 'download-btn__disabled' : ''}`}
                                onClick={() => {
                                  setOpenPopover(true);
                                }}
                              >
                                <H3Text
                                  text={(
                                    <FontAwesomeIcon icon={faDownload} />
                                  )}
                                  className="action-button"
                                />
                              </div>
                            </Popover>

                          )
                        }
                        <H3DateSelector
                          selectedInterval={orderDateSelectedIntervalDateRangeType}
                          startDate={startDate}
                          endDate={endDate}
                          onDateChangeWithDateRangeType={({ date, dateRangeType }) => {
                            setStartDate(dayjs(date[0])?.startOf('day').valueOf());
                            setEndDate(dayjs(date[1])?.endOf('day').valueOf());
                            setCurrentPage(1);
                            setOrderDateSelectedIntervalDateRangeType(dateRangeType);
                          }}
                        />
                        {!isMobileOrPortrait && selectedRows?.length > 0 && (
                          <Dropdown
                            overlay={(
                              <Menu>
                                <Menu.Item>
                                  <div onClick={() => setCreatePoDrawer(true)}>
                                    + Purchase Orders
                                  </div>
                                </Menu.Item>
                                <Menu.Item>
                                  <div onClick={() => setCreateStDrawer(true)}>
                                    + Stock Transfer
                                  </div>
                                </Menu.Item>
                              </Menu>
                            )}
                            placement="bottomLeft"
                            trigger={['click']}
                            getPopupContainer={(triggerNode) => triggerNode.parentNode}
                          >
                            <div className="doc-list__action-buttons">
                              <div className="action-button">
                                <H3Text text="Actions" className="action-button-text" />
                                <FontAwesomeIcon icon={faCaretDown} />
                              </div>
                            </div>
                          </Dropdown>
                        )}
                        <Dropdown
                          trigger={['click']}
                          overlay={(
                            <div className="header__filter__container">
                              <div className="header__filter__container__title">
                                Apply Filters
                              </div>
                              <div className="filter__container filter__container-section">
                                <div className="filter__title"> Select Business Unit </div>
                                <div className="sales-orders__header__section-status">
                                  <TenantSelector
                                    selectedTenant={selectedTenant}
                                    showSearch
                                    showAll={false}
                                    noDropdownAlign
                                    isMultiple
                                    onChange={(value) => {
                                      if (value === 'All') {
                                        setCurrentPage(1);
                                        setSelectedTenant(Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.PURCHASE_REQUEST, Helpers.permissionTypes.READ));
                                      } else {
                                        setCurrentPage(1);
                                        setSelectedTenant(value);
                                      }
                                    }}
                                    placeholder="Select Business Unit"
                                    hideTitle
                                    includedTenants={Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.PURCHASE_REQUEST, Helpers.permissionTypes.READ)}
                                  />
                                </div>
                              </div>
                              <div className="filter__container filter__container-section">
                                <div className="filter__title"> Select Department </div>
                                <div className="sales-orders__header__section-status">
                                  <SelectDepartment
                                    title="Select Department"
                                    hideTitle
                                    selectedDepartment={Number(selectedDepartment) || ''}
                                    noDropdownAlign
                                    onChange={(value) => {
                                      setSelectedDepartment(value?.department_id.toString() || '');
                                      setCurrentPage(1);
                                    }}
                                    disabled={departmentLevelVisibility}
                                  />
                                </div>
                              </div>
                              <div className="filter__container filter__container-section">
                                <div className="filter__title"> Order Status </div>
                                <PRZSelect
                                  value={selectedStatus}
                                  onChange={(value) => {
                                    setSelectedStatus(value);
                                    setCurrentPage(1);
                                  }}
                                  placeholder="Search by status.."
                                  options={materialRequestStatusOptions}
                                />
                              </div>
                              <div className="filter__container filter__container-section">
                                <div className="filter__title"> Fulfillment Status </div>
                                <PRZSelect
                                  value={selectedFulfillmentStatus}
                                  onChange={(value) => {
                                    setSelectedFulfillmentStatus(value);
                                    setCurrentPage(1);
                                  }}
                                  placeholder="Search by status.."
                                  options={fulfillmentStatusOptions}
                                />
                              </div>
                              <div className="filter__container">
                                <div className="filter__title"> Select Labels </div>
                                <div className="sales-orders__header__section-status">
                                  <TagSelector
                                    filter
                                    entityType="PURCHASE_ORDER"
                                    selectedTags={selectedTag}
                                    showSearch
                                    showAll={false}
                                    noDropdownAlign
                                    isMultiple
                                    onChange={(value) => {
                                      setCurrentPage(1);
                                      setSelectedTag(value);
                                    }}
                                    placeholder="Select Label"
                                    hideTitle
                                    hideCSS
                                  />
                                </div>
                              </div>
                            </div>
                          )}
                        >
                          <div className="doc-list__action-buttons">
                            <div className="action-button">
                              <H3Text text="Filters" className="action-button-text" />
                              <FilterOutlined />
                            </div>
                          </div>
                        </Dropdown>
                        <Dropdown
                          overlay={(
                            <div className="custom-columns__content">
                              <div className="custom-columns__content-section">
                                <H3Text text="Visible Columns" className="custom-columns__content-title" />
                                {
                                  Object.keys(visibleColumns).filter((item) => visibleColumns[item]?.visible)?.map((key) => (
                                    <div key={key}>
                                      <Checkbox
                                        disabled={fixedColumns.includes(key)}
                                        checked={visibleColumns[key]?.visible}
                                        onChange={(value) => {
                                          const visibleColumnsCopy = JSON.parse(JSON.stringify(visibleColumns));
                                          visibleColumnsCopy[key].visible = !visibleColumnsCopy[key].visible;
                                          localStorage.setItem('prcz-page-columns-pr', JSON.stringify(visibleColumnsCopy));
                                          setVisibleColumns(visibleColumnsCopy);
                                        }}
                                      >
                                        {visibleColumns[key]?.label}
                                      </Checkbox>
                                    </div>
                                  ))
                                }
                              </div>
                              {Object.keys(visibleColumns).filter((item) => !visibleColumns[item]?.visible)?.length ? (
                                <div className="custom-columns__content-section">
                                  <H3Text text="Hidden Columns" className="custom-columns__content-title" />
                                  {
                                    Object.keys(visibleColumns).filter((item) => !visibleColumns[item]?.visible)?.map((key) => (
                                      <div key={key}>
                                        <Checkbox
                                          disabled={fixedColumns.includes(key)}
                                          checked={visibleColumns[key]?.visible}
                                          onChange={(value) => {
                                            const visibleColumnsCopy = JSON.parse(JSON.stringify(visibleColumns));
                                            visibleColumnsCopy[key].visible = !visibleColumnsCopy[key].visible;
                                            localStorage.setItem('prcz-page-columns-pr', JSON.stringify(visibleColumnsCopy));
                                            setVisibleColumns(visibleColumnsCopy);
                                          }}
                                        >
                                          {visibleColumns[key]?.label}
                                        </Checkbox>
                                      </div>
                                    ))
                                  }
                                </div>
                              ) : ''}
                            </div>
                          )}
                          trigger={['click']}
                          placement="bottomRight"
                        >
                          <div className="custom-columns__wrapper">
                            Customize Columns
                            <ControlOutlined />
                          </div>
                        </Dropdown>
                      </div>
                    </div>
                  </div>
                )}
                bordered
                loading={getPurchaseRequestsLoading || savedFilterViewsLoading}
                showHeader
                size="small"
                scroll={!isMobileOrPortrait && !!getDataSource(purchaseRequests?.purchase_requisition)?.length ? { x: 'max-content', y: 'calc(100dvh - 180px)' } : { x: 'max-content' }}
                sticky={!isMobileOrPortrait && !!getDataSource(purchaseRequests?.purchase_requisition)?.length}
                columns={getPurchaseRequestColumns()}
                rowSelection={!isMobileOrPortrait
                  ? (Helpers.getPermission(Helpers.permissionEntities.PURCHASE_ORDER, Helpers.permissionTypes.CREATE, user) && {
                    type: 'checkbox',
                    selectedRowKeys,
                    onChange: (selectedRowKeys, selectedRowsForSelection) => {
                      setSelectedRows(selectedRowsForSelection);
                      setSelectedRowKeys(selectedRowKeys);
                    },
                    getCheckboxProps: (record) => ({
                      disabled: (record.status?.toUpperCase() !== 'ISSUED' && Helpers.getTenantEntityPermission(user?.user_tenants, Helpers.permissionEntities.PURCHASE_ORDER, Helpers.permissionTypes.CREATE).includes(record?.tenant_id)) || isRowDisabled(record),
                    }),
                  }) : false}
                dataSource={getDataSource(purchaseRequests?.purchase_requisition) || []}
                pagination={{
                  defaultCurrent: 1,
                  current: currentPage,
                  total: purchaseRequests ? purchaseRequests?.count : 0,
                  pageSize: limit,
                  onChange: (page, pageSize) => {
                    setCurrentPage(page);
                    setLimit(pageSize);
                  },
                  position: ['bottomLeft'],
                  pageSizeOptions: ['10', '25', '50', '100'],
                  showTotal: (tot, range) => `${range[0]}-${range[1]} of ${tot} items`,
                  showSizeChanger: true,
                }}
                rowClassName={(record) => (isRowDisabled(record) ? 'disabled-rows' : '')}
              />
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
}

const mapStateToProps = ({
  UserReducers, PurchaseRequestReducers, CFV2Reducers, DepartmentReducers, ProductReducers,
}) => ({
  user: UserReducers.user,
  purchaseRequests: PurchaseRequestReducers.purchaseRequests,
  getPurchaseRequestsLoading: PurchaseRequestReducers.getPurchaseRequestsLoading,
  getDownloadPRLoading: PurchaseRequestReducers.getDownloadPRLoading,
  customFieldsProps: CFV2Reducers.cfV2DocPurchaseRequest,
  getDocCFV2Loading: CFV2Reducers.getDocCFV2Loading,
  departments: DepartmentReducers.departments,
  products: ProductReducers.products,
  getProductsLoading: ProductReducers.getProductsLoading,
});

const mapDispatchToProps = (dispatch) => ({
  downloadPRData: (payload, callback) => dispatch(PurchaseRequestActions.downloadPRData(payload, callback)),
  getPurchaseRequests: (tenantId, status, fromDate, toDate, deliveryFromDate, deliveryToDate, tenantRoleId, page, limit, callback, searchKeyword, tenantDepartmentId, moId, prId, sourceDepartmentId, departmentId, productSearch, label, mrpId, fulfillmentStatus, isListScreen) => dispatch(PurchaseRequestActions.getPurchaseRequests(tenantId, status, fromDate, toDate, deliveryFromDate, deliveryToDate, tenantRoleId, page, limit, callback, searchKeyword, tenantDepartmentId, moId, prId, sourceDepartmentId, departmentId, productSearch, label, mrpId, fulfillmentStatus, isListScreen)),
  getPurchaseRequestsSuccess: (purchaseRequests) => dispatch(PurchaseRequestActions.getPurchaseRequestsSuccess(purchaseRequests)),
  getDepartments: (keyword, tenantId, page, limit, departmentId, callback) => dispatch(
    DepartmentActions.getDepartments(keyword, tenantId, page, limit, departmentId, callback),
  ),
  getDocCFV2: (payload, callback) => dispatch(CFV2Actions.getDocCFV2(payload, callback)),
  getDocCFV2Success: (cf) => dispatch(CFV2Actions.getDocCFV2Success(cf)),
  getProducts: (keyword, tenantId, stockStatus, limit, page, tenantDepartmentId, excludeOutOfStock, productType, category, isSalesProduct, isPurchaseProduct, search, sortBy, filterReservedQuantity, barcode, isShopifyProduct, isMarketplaceProduct) => dispatch(ProductActions.getProducts(keyword, tenantId, stockStatus, limit, page, tenantDepartmentId, excludeOutOfStock, productType, category, isSalesProduct, isPurchaseProduct, search, sortBy, filterReservedQuantity, barcode, isShopifyProduct, isMarketplaceProduct)),
});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PurchaseRequestsList));
